import angular from 'angular';
import './resource';

const module = angular.module('whyline.resources.tags-groups', ['whyline.resources.resource']);

const TagsGroupsFactory = (Resource, $http, $timeout, API_URL) => {
  /* @ngInject */
  // API REST Resource Name
  const _type = 'tags-groups?organizationId';

  const _schema = {
    _id: String,
    organizationId: String,
    name: String,
    order: Number,
    tags: [
      {
        placeIds: [String],
        tagName: String,
      },
    ],
  };

  const TagsGroups = function(data) {
    angular.forEach(_schema, (prop, key) => {
      this[key] = prop.default;
    });

    angular.forEach(data, (prop, key) => {
      this[key] = prop;
    });

    this.enable = (enabled) => {
      const promise = $http.put(`${API_URL}tags-groups/${this._id}/enabled?organizationId`, {
        enabled,
      });
      promise.then((response) => {
        const item = response.data;

        $timeout(() => {
          TagsGroups.UpdateCache(item._id, item);
        });

        return TagsGroups.GetOneFromCache('_id', this._id);
      });

      return promise;
    };
  };

  TagsGroups.prototype = new Resource(_type, _schema, TagsGroups);

  Resource.Extend(_type, TagsGroups);

  TagsGroups.UpdateTags = async (tagGroupId, tags) => {
    const url = `${API_URL}tags-groups/${tagGroupId}/tags?organizationId`;

    return $http({
      method: 'PUT',
      url,
      data: { tags },
    }).then((response) => {
      const tagGroup = response.data;
      $timeout(() => {
        TagsGroups.UpdateCache(tagGroup._id, tagGroup);
      });
      return Promise.resolve(tagGroup);
    });
  };

  // One minute
  const validityTime = 1 * 60 * 1000;
  TagsGroups.InitCache(validityTime);

  return TagsGroups;
};

module.exports = module.factory('TagsGroups', TagsGroupsFactory);
